import { Grid, Typography } from "@mui/material";
import { formatNumberWithComma } from "../../config";

export default function RCSOverviewColumn({ total, disabled, enabled }) {
    return (
        <Grid
            container
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
            }}
        >
            <Grid
                item
                md={12}
                sx={{
                    alignItems: "center",
                    justifyContent: "start",
                    flexWrap: "wrap !important",
                }}
                gap={15}
            >
                <Grid>
                    <Typography
                        sx={{
                            fontSize: "0.7rem !important",
                            fontWeight: "bold",
                        }}
                    >
                        TOTAL :{" "}
                        {formatNumberWithComma(total) ?? "-"}
                    </Typography>
                </Grid>

                <Grid>
                    <Typography
                        sx={{
                            fontSize: "0.7rem !important",
                            fontWeight: "bold",
                            color: "blueviolet"
                        }}
                    >
                        ENABLED :{" "}
                        {formatNumberWithComma(enabled) ?? "-"}
                    </Typography>
                </Grid>
                
                <Grid>
                    <Typography
                        color="GrayText"
                        sx={{
                            display: "flex",
                            fontSize: "0.7rem !important",
                            fontWeight: "bold",
                        }}
                    >
                        DISABLED :{" "}
                        {formatNumberWithComma(disabled) ?? "-"}
                    </Typography>
                </Grid>
            </Grid>
        </Grid>
    );
}
